export class LoginDetails {
    public studentId: string;
    public familyName: string;
    public dateOfBirth: string;
    public dateOfBirthFormatted: string;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/model/LoginDetails.ts